import type {SubmitEvent} from 'react'
import {useState} from 'react'
import {useNavigate} from 'react-router'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import ApiHelper from '@freckle/school/ts/common/helpers/api-helper'
import Notification from '@freckle/school/ts/common/helpers/notification'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import LoginView from '@freckle/school/ts/pages/login/login-view'

export default function Login() {
  const navigate = useNavigate()
  const {t} = useSafeTranslation()
  const [state, setState] = useState({
    email: '',
    password: '',
    disabled: false,
  })
  const onChangeEmail = (email: string) => {
    setState({...state, email})
  }

  const onChangePassword = (password: string) => {
    setState({...state, password})
  }

  const onSubmitLogin = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {email, password} = state
    setState({...state, disabled: true})

    const trimmedEmail = email.trim()
    const trimmedPassword = password.trim()

    ApiHelper.login(trimmedEmail, trimmedPassword).then(
      () => {
        navigate(Routes.redirectAuthenticated())
      },
      () => {
        setState({...state, disabled: false})
        Notification.displayErrorNotification(t('LOGIN_PAGE_ERROR_MESSAGE_TEXT'), 5)
      },
    )
  }

  return (
    <LoginView
      email={state.email}
      password={state.password}
      disabled={state.disabled}
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onSubmitLogin={onSubmitLogin}
    />
  )
}
